import breakpoint from '../util/breakpoint';

export default class HeadNav {
  /**
   * Navigation toggling
   * Element `#head-nav` triggers `open` and `close` custom events which can be catched by other scripts
   */
  constructor() {
    const navButton = document.getElementById('head-nav-button');
    navButton.addEventListener('click', this.toggleNav.bind(this));
    window.addEventListener('custom-resize', this.onResize.bind(this));
    window.addEventListener('scroll', this.onScroll.bind(this));
    this.initialize();
  }

  /**
   * Initialize navigation
   */
  initialize() {
    // const isMobile =
    //   window.matchMedia(breakpoint.breakpointDown('md')).matches ||
    //   document.querySelector('html').classList.contains('is-mobile');
    // const head = document.getElementById('head');
    // const nav = document.getElementById('head-nav');
    // const button = document.getElementById('head-nav-button');
    // // this.scrollPosition = window.scrollY;
    // if (isMobile) {
    //   nav.insertBefore(button, nav.firstChild);
    //   if (!nav.classList.contains('is-active')) {
    //     button.setAttribute('aria-expanded', 'false');
    //     document.getElementById('head-nav-primary').hidden = true;
    //   }
    // } else {
    //   button.setAttribute('aria-expanded', 'true');
    //   head.parentElement.insertBefore(button, head);
    //   document.getElementById('head-nav-primary').hidden = false;
    // }
  }

  /**
   * Toggle navigation
   *
   * @param {MouseEvent} e
   */
  toggleNav(e) {
    e.preventDefault();
    e.currentTarget.blur();

    // const head = document.getElementById('head');
    const nav = document.getElementById('head-nav');
    const button = document.getElementById('head-nav-button');
    const menu = document.getElementById('head-nav-primary');
    const isMobile =
      window.matchMedia(breakpoint.breakpointDown('md')).matches ||
      document.querySelector('html').classList.contains('is-mobile');

    nav.classList.toggle('is-active');
    if (nav.classList.contains('is-active')) {
      button.setAttribute('aria-expanded', 'true');
      if (isMobile) {
        const logo = document.querySelector('#head .head-logo').cloneNode(true);
        // console.info(logo);
        const logoImg = logo.querySelector('img');
        const src = logoImg.src;
        logoImg.src = logoImg.getAttribute('data-src-alt');
        logoImg.setAttribute('data-src-alt', src);
        nav.insertBefore(logo, nav.firstChild);
        menu.hidden = false;
      }
      nav.dispatchEvent(new CustomEvent('open'));
    } else {
      setTimeout(() => {
        button.setAttribute('aria-expanded', 'false');
      }, 500);
      if (isMobile) {
        nav.classList.add('is-hiding');
        setTimeout(() => {
          nav.removeChild(nav.querySelector('.head-logo'));
          menu.hidden = true;
          nav.classList.remove('is-hiding');
        }, 550);
      }
      nav.dispatchEvent(new CustomEvent('close'));
    }
    if (isMobile) {
      setTimeout(() => {
        this.toggleNavIcon();
      }, 500);
    }
  }

  /**
   * Toggle navigation icon
   */
  toggleNavIcon() {
    const nav = document.getElementById('head-nav');
    const buttonText = nav.querySelector('.nav-button-text');
    const buttonIcon = nav.querySelector('.nav-button-icon').firstElementChild;
    const newText = buttonText.getAttribute('data-close');
    const oldText = buttonText.textContent;
    const newIcon = buttonIcon.getAttribute('data-close');
    const oldIcon = buttonIcon.getAttribute('class');
    buttonText.setAttribute('data-close', oldText);
    buttonText.textContent = newText;
    buttonIcon.setAttribute('data-close', oldIcon);
    buttonIcon.setAttribute('class', newIcon);
  }

  /**
   * window.custom-resize handler
   *
   * @param {CustomEvent} e
   */
  onResize(e) {
    if (e.detail.width) {
      /** Reset */
      this.initialize();
    }
  }

  /**
   * Delayed `window.scroll` event handler
   */
  onScroll() {
    if (!this.delayedScroll) {
      this.delayedScroll = true;
      setTimeout(() => {
        this.delayedScroll = false;
        const head = document.getElementById('head');
        if (window.scrollY > 0) {
          if (!head.classList.contains('is-scrolled')) {
            head.classList.add('is-scrolled');
          }
        } else {
          head.classList.remove('is-scrolled');
        }
      }, 100);
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/HeadNav.js